var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.11 2H2.88776C1.90732 2 1.10999 2.79733 1.10999 3.77778V16.2222C1.10999 17.2027 1.90732 18 2.88776 18H17.11C18.0904 18 18.8878 17.2027 18.8878 16.2222V3.77778C18.8878 2.79733 18.0904 2 17.11 2ZM2.88776 16.2222V5.55556H17.11L17.1118 16.2222H2.88776Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59266 7.59375L4.29755 10.8889L7.59266 14.184L8.84955 12.9271L6.81133 10.8889L8.84955 8.85064L7.59266 7.59375ZM12.4051 7.59375L11.1482 8.85064L13.1864 10.8889L11.1482 12.9271L12.4051 14.184L15.7002 10.8889L12.4051 7.59375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewCode);
export default __webpack_public_path__ + "static/media/ViewCode.b47eed5d3d48b1a7dfa089c3446db17d.svg";
export { ForwardRef as ReactComponent };